/**
 * HR Reports Tab Component
 * Displays available reports and analytics
 */

import React from 'react';
import { FileText, BarChart3, Users, Clock, Download } from 'lucide-react';

const HRReportsTab = () => {
  const reports = [
    {
      id: 'offers-by-client',
      title: 'Accepted Offers by Client',
      description: 'View all accepted offers grouped by client',
      icon: FileText,
      color: 'blue'
    },
    {
      id: 'onboard-duration',
      title: 'Offer-to-Onboard Duration',
      description: 'Average time from offer acceptance to onboarding',
      icon: BarChart3,
      color: 'blue'
    },
    {
      id: 'recruiter-productivity',
      title: 'Recruiter Productivity',
      description: 'Offers accepted and onboarded by recruiter',
      icon: Users,
      color: 'blue'
    },
    {
      id: 'aging-analysis',
      title: 'Candidate Aging Analysis',
      description: 'Candidates by days since offer acceptance',
      icon: Clock,
      color: 'blue'
    }
  ];

  const handleExport = (reportId) => {
    // TODO: Implement report export functionality
    console.log(`Exporting report: ${reportId}`);
  };

  return (
    <div className="space-y-6" data-testid="hr-reports-tab">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {reports.map(report => {
          const Icon = report.icon;
          return (
            <div 
              key={report.id} 
              className="bg-white rounded-lg shadow-sm border border-gray-200 p-6"
              data-testid={`report-card-${report.id}`}
            >
              <h3 className="font-semibold text-gray-900 mb-2 flex items-center gap-2">
                <Icon className={`h-5 w-5 text-${report.color}-600`} />
                {report.title}
              </h3>
              <p className="text-sm text-gray-600 mb-4">{report.description}</p>
              <button 
                onClick={() => handleExport(report.id)}
                className={`w-full px-4 py-2 bg-${report.color}-600 text-white rounded-lg hover:bg-${report.color}-700 flex items-center justify-center gap-2 transition-colors`}
                data-testid={`export-btn-${report.id}`}
              >
                <Download className="h-4 w-4" />
                Export Report
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default HRReportsTab;
